export const ECHECK = 'eCheck';
export const CARD = 'card';
